import { useLanguage, t } from "../../../i18n";
import React from "react";
import { Card, Row, Col } from "react-bootstrap";
import InfoPill from "../InfoPill/InfoPill";
import "./ProfileInfoCard.css";
export default function ProfileInfoCard({
  title,
  items
}) {
  useLanguage();
  return <Card className="bb-profile-info-card">
      <Card.Body>
        <h3 className="bb-profile-info-card__title">{t(title)}</h3>

        <Row className="g-3">
          {items.map(item => <Col key={item.label} md={6} xl={4}>
              <InfoPill label={t(item.label)} value={item.value} translateValue={!["Full Name", "Email Address", "Contact Number", "WhatsApp Number", "Occupation"].includes(item.label)} />
            </Col>)}
        </Row>
      </Card.Body>
    </Card>;
}
